module.exports = __webpack_public_path__ + "img/lamp_close.09b91924.png";